/*
  Jonelia Health – Barrierefreiheit (WCAG 2.1 AA / EN 301 549).

  Ergaenzt ausschliesslich Tastaturverhalten, das im Theme-Kern fehlt.
  Nichts davon veraendert das Aussehen oder die Funktion mit der Maus:

  1. Mobilmenue: Escape schliesst, der Fokus wandert beim Oeffnen hinein
     und beim Schliessen zurueck auf die Schaltflaeche (2.1.1, 2.4.3).
  2. Nelia-Dialog: der Fokus kehrt beim Schliessen zum Aufrufknopf zurueck
     (2.4.3). Escape war bereits umgesetzt.
  3. Die Beschriftung der Menue-Schaltflaeche wechselt zwischen
     "oeffnen" und "schliessen" (4.1.2).
  4. Gesundheits-Check: Fokus beim Start und beim Ergebnis (2.4.3).
  5. Karussells: ausgeblendete Folien bleiben nicht in der Tabreihenfolge
     (2.4.3, 4.1.2).
*/
(function () {
  'use strict';

  function focusables(root) {
    if (!root) return [];
    var sel = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(root.querySelectorAll(sel), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
    });
  }

  /* ---------------------------------------------------------------- 1 + 3 */
  var menuToggle = document.querySelector('.header__mobile-nav-toggle');
  var drawer = document.getElementById('mobile-menu');

  if (menuToggle && drawer) {
    var openLabel = menuToggle.getAttribute('aria-label') || '';
    var closeLabel = 'Menü schließen';

    if (!drawer.hasAttribute('tabindex')) drawer.setAttribute('tabindex', '-1');

    var applyState = function (isOpen) {
      menuToggle.setAttribute('aria-label', isOpen ? closeLabel : openLabel);
    };

    new MutationObserver(function () {
      var isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      applyState(isOpen);
      if (isOpen && !drawer.contains(document.activeElement)) {
        // Der Fokus soll im geoeffneten Menue landen, nicht dahinter.
        window.setTimeout(function () {
          var first = focusables(drawer)[0];
          (first || drawer).focus({ preventScroll: true });
        }, 60);
      }
    }).observe(menuToggle, { attributes: true, attributeFilter: ['aria-expanded'] });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      if (menuToggle.getAttribute('aria-expanded') !== 'true') return;
      menuToggle.click();
      menuToggle.focus({ preventScroll: true });
    });

    // Solange das Menue den Bildschirm bedeckt, bleibt der Tabulator darin.
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      if (menuToggle.getAttribute('aria-expanded') !== 'true') return;
      var list = [menuToggle].concat(focusables(drawer));
      if (list.length < 2) return;
      var at = list.indexOf(document.activeElement);
      var next;
      if (at === -1) {
        next = list[0];
      } else {
        next = event.shiftKey
          ? list[(at - 1 + list.length) % list.length]
          : list[(at + 1) % list.length];
      }
      event.preventDefault();
      next.focus({ preventScroll: true });
    });
  }

  /* -------------------------------------------------------------------- 2 */
  var neliaLaunch = document.querySelector('.jon-nelia__launch');
  if (neliaLaunch) {
    var wasOpen = neliaLaunch.getAttribute('aria-expanded') === 'true';
    new MutationObserver(function () {
      var isOpen = neliaLaunch.getAttribute('aria-expanded') === 'true';
      if (wasOpen && !isOpen) {
        // Dialog geschlossen: Fokus zurueck auf den Aufrufknopf.
        window.setTimeout(function () {
          if (document.activeElement === document.body) {
            neliaLaunch.focus({ preventScroll: true });
          }
        }, 40);
      }
      wasOpen = isOpen;
    }).observe(neliaLaunch, { attributes: true, attributeFilter: ['aria-expanded'] });
  }
  /* -------------------------------------------------------------------- 4 */
  /* Gesundheits-Check: der Fokus folgt dem Schrittwechsel. Beim Start und
     beim Ergebnis machte das Skript des Checks das bisher nicht, der Fokus
     blieb dann auf einem ausgeblendeten Element zurueck (2.4.3). */
  var check = document.querySelector('[data-jon-check]');
  if (check) {
    var checkForm = check.querySelector('[data-ck-form]');
    var checkStart = check.querySelector('[data-ck-start]');
    var checkResult = check.querySelector('[data-ck-result]');

    if (checkStart && checkForm) {
      checkStart.addEventListener('click', function () {
        window.setTimeout(function () {
          var first = checkForm.querySelector('[data-ck-step="1"] input, [data-ck-step="1"] select');
          if (first) first.focus({ preventScroll: true });
        }, 80);
      });
    }

    if (checkResult) {
      new MutationObserver(function () {
        if (checkResult.hasAttribute('hidden')) {
          checkResult.removeAttribute('tabindex');
          return;
        }
        checkResult.setAttribute('tabindex', '-1');
        window.setTimeout(function () {
          checkResult.focus({ preventScroll: true });
        }, 80);
      }).observe(checkResult, { attributes: true, attributeFilter: ['hidden'] });
    }
  }
  /* -------------------------------------------------------------------- 5 */
  /* Karussells (Flickity): Folien, die aus dem Bild geschoben sind, tragen
     aria-hidden="true", ihre Links blieben aber per Tabulator erreichbar.
     Der Fokus landete dann auf unsichtbaren Produktkacheln (2.4.3, 4.1.2).
     Hier wird nur die Tabreihenfolge angepasst, das Klickverhalten nicht. */
  var FOCUS_SEL = 'a[href],button,input,select,textarea,[tabindex]';

  function syncHiddenSlide(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    var items = cell.querySelectorAll(FOCUS_SEL);
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (hidden) {
        if (!el.hasAttribute('data-a11y-ti')) {
          el.setAttribute('data-a11y-ti', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
          el.setAttribute('tabindex', '-1');
        }
      } else if (el.hasAttribute('data-a11y-ti')) {
        var prev = el.getAttribute('data-a11y-ti');
        if (prev === '') { el.removeAttribute('tabindex'); } else { el.setAttribute('tabindex', prev); }
        el.removeAttribute('data-a11y-ti');
      }
    }
  }

  function scanCarousels() {
    var cells = document.querySelectorAll('.flickity-slider > [aria-hidden], .flickity-viewport [aria-hidden="true"]');
    for (var i = 0; i < cells.length; i++) syncHiddenSlide(cells[i]);
  }

  var carouselObserver = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      if (t.nodeType === 1 && t.hasAttribute('aria-hidden')) syncHiddenSlide(t);
    }
  });

  function startCarouselWatch() {
    scanCarousels();
    carouselObserver.observe(document.body, {
      subtree: true, attributes: true, attributeFilter: ['aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.setTimeout(startCarouselWatch, 400); });
  } else {
    window.setTimeout(startCarouselWatch, 400);
  }
  window.addEventListener('load', function () { window.setTimeout(scanCarousels, 600); });
})();
